export default __webpack_public_path__ + "static/media/sarkodie.9b69f0c9.jpg";